import moment from 'moment'
import pageType from '../enums/pageType'
import optionType from '@/components/menus/ticket/enums/ticketListOptionType'

const headerDataMapping = {
  dispId: {'value': 'dispId', 'label': 'id', 'sort': 1},
  subject: {'value': 'subject', 'label': 'タイトル', 'sort': 2},
  customerName: {'value': 'customerName', 'label': '顧客名', 'sort': 3},
  createDate: {'value': 'createDate', 'label': '要請日', 'sort': 4},
  priority: {'value': 'priority', 'label': '優先順位', 'sort': 5},
  status: {'value': 'status', 'label': '状態', 'sort': 6},
  agentName: {'value': 'agentName', 'label': '担当者', 'sort': 7},
  majorTaskType: {'value': 'majorTaskType', 'label': '大分類', 'sort': 8},
  middleTaskType: {'value': 'middleTaskType', 'label': '中分類', 'sort': 9},
  minorTaskType: {'value': 'minorTaskType', 'label': '小分類', 'sort': 10},
  memo: {'value': 'memo', 'label': 'メモ', 'sort': 11},
  modifyDate: {'value': 'modifyDate', 'label': '最近のアップデート', 'sort': 12},
  ticketIncomingChannel: {'value': 'ticketIncomingChannel', 'label': 'チャットツール', 'sort': 13},
  tags: {'value': 'tags', 'label': 'タグ', 'sort': 14}
}

function listIntoGetParams (paramName, listData) {
  let result = ''
  listData.forEach((data) => {
    result += (paramName + '=' + data + '&')
  })
  return result
}
function parsePriority (priority) {
  if (priority === 'LOW') {
    return '低い'
  } else if (priority === 'NORMAL') {
    return '普通'
  } else if (priority === 'HIGH') {
    return '高い'
  } else if (priority === 'EMERGENCY') {
    return '緊急'
  } else {
    return '優先順位エラー'
  }
}

function parseStatus (status) {
  if (status === 'ACTIVE') {
    return '有効'
  } else if (status === 'PENDING') {
    return '保留'
  } else if (status === 'RESOLVED') {
    return '解決'
  } else if (status === 'INACTIVE') {
    return '無効'
  } else {
    return '状態値エラー'
  }
}

function parseIncomingChannel (channel) {
  if (channel === 'MEMO') {
    return 'メモ'
  } else if (channel === 'CALL') {
    return '電話'
  } else if (channel === 'TALK') {
    return 'チャット'
  } else if (channel === 'CHAT_BOT') {
    return 'チャットボット'
  } else if (channel === 'MESSAGE') {
    return 'メッセージ'
  } else if (channel === 'MAIL') {
    return 'メール'
  } else {
    return 'チャットツールエラー'
  }
}

function parseTicketEnumIntoString (data, type) {
  if (type === 'status') {
    return parseStatus(data)
  } else if (type === 'priority') {
    return parsePriority(data)
  } else if (type === 'createDate' || type === 'modifyDate') {
    return moment(data, 'YYYYMMDDHHmmSS').format('YYYY-MM-DD HH:mm:SS')
  } else if (type === 'ticketIncomingChannel') {
    return parseIncomingChannel(data)
  } else {
    return data
  }
}

function getStyleFromTypeText (type, text) {
  if (type === 'status') {
    switch (text) {
      case '有効':
        return {color: '#f38772'}
      case '無効':
        return {color: '#817F7F'}
      case '解決':
        return {color: '#009377'}
      case '保留':
        return {color: '#007BF5'}
    }
  } else if (type === 'priority') {
    switch (text) {
      case '低い':
        return {color: '#888686'}
      case '普通':
        return null // 보통일 경우 기본 값.
      case '高い':
        return {fontWeight: '600', color: '#000000'}
      case '緊急':
        return {fontWeight: '700', color: '#FB607B'}
    }
  }
  return null
}

function checkItemInTicketSelectedArray (arr, ticketId) {
  let result = {
    result: false,
    index: 0
  }
  arr.forEach((tmp, index) => {
    if (tmp.id === ticketId) {
      result.result = true
      result.index = index
    }
  })
  return result
}

const getChannelIcon = (channelName) => {
  if (channelName === 'CALL') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/new-call.png'
  } else if (channelName === 'MEMO') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/ticket_memo.png'
  } else if (channelName === 'KAKAO_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/kakao-icon.png'
  } else if (channelName === 'NAVER_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/naver-talk-icon.png'
  } else if (channelName === 'WEB_CHAT') {
    // return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/web-talk-icon.png'
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/web-talk2-icon.png'
  } else if (channelName === 'TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/talk.png'
  } else if (channelName === 'CHAT_BOT') {
    // return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/chatbot/chatbot-icon.png'
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/chatbot/chatbot2-icon.png'
  } else if (channelName === 'MESSAGE') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/message.png'
  } else if (channelName === 'FACEBOOK_TALK') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/facebook-icon.png'
  } else if (channelName === 'LINE') {
    return '//public-common-sdk-outaigate.s3.ap-northeast-3.amazonaws.com/image/LINE_logo.png'
  } else if (channelName === 'MAIL') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/mail-icon.png'
  } else if (channelName === 'SURVEY') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/survey/survey.png'
  } else if (channelName === 'CUSTOM') {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/icon_ticket_api.png'
  } else {
    return '//public-common-sdk.s3.ap-northeast-2.amazonaws.com/image/front-static/avatars/brand-profile-img.png'
  }
}

function getTicketIdsFromTicketArr (arr) {
  let result = []
  arr.forEach((ticket) => {
    result.push(ticket.id)
  })
  return result
}

function parseHeaderIntoJson (arr) {
  let result = []
  arr.forEach((data) => {
    let temp = headerDataMapping[data]
    let resTemp = {
      text: temp.label,
      align: 'center',
      value: temp.value,
      sortable: false,
      sort: headerDataMapping[temp.value].sort
    }
    result.push(resTemp)
  })
  // TODO 정렬 기능을 제공 할것인가, or 각자 순서도 커스터마이징?
  // result.sort((a, b) =>  a.sort < b.sort ? -1 : 1)
  return result
}

function parseJsonIntoHeader (rawData) {
  let data = JSON.parse(rawData)
  let result = []
  data.forEach((row) => {
    result.push(row.value)
  })
  return result
}

function getLeafTaskType (major, middle, minor) {
  if (minor) { return minor }
  if (middle) { return middle }
  if (major) { return major }
  return null
}

function parseStoreJsonIntoHeaderStringArr (jsonArr) {
  let result = []
  jsonArr.forEach((row) => {
    result.push(row.value)
  })
  return result
}

function getExcelDownloadTimeLimitOverFlow (startDate, endDate) {
  let diffTime = moment(endDate, 'YYYYMMDD').diff(moment(startDate, 'YYYYMMDD'))
  let duration = moment.duration(diffTime)
  let days = Math.floor(duration.asDays())
  return days <= 90
}

function checkSelectionReset (data) {
  return data === '-'
}

function findTaskType (taskTypes, targetType) {
  let isExist = false
  let temp = {}
  taskTypes.forEach((taskType) => {
    if (taskType.classification === targetType) {
      isExist = true
      temp.taskTypeId = taskType.taskTypeId
      temp.taskTypeName = taskType.taskName
    }
  })
  if (isExist) { return temp } else { return null }
}

function getAvailTaskTypeId (data) {
  if (data) {
    data = data.taskTypeId ? data.taskTypeId : data
    return data
  } else {
    return null
  }
}

function checkEndTimeIsAfter (startDate, endDate) {
  return moment(endDate).isAfter(startDate) || startDate === endDate
}

function parseJsonIntoPage (page, jsonArr) {
  const option = jsonArr
  if (option.length < 1) {
    return null
  }

  if (page === pageType.MY_PAGE) {
    return option.myPage
  } else if (page === pageType.ALL_PAGE) {
    return option.allPage
  } else if (page === pageType.RECENT_UPDATED_PAGE) {
    return option.recentUpdatedPage
  } else if (page === pageType.COMPLETED_PAGE) {
    return option.completedPage
  }
}

function parseJsonIntoOption (page, type, jsonArr) {
  let option = []
  let pageName = ''
  if (jsonArr !== undefined) {
    if (page === pageType.MY_PAGE) {
      pageName = 'myPage'
    } else if (page === pageType.ALL_PAGE) {
      pageName = 'allPage'
    } else if (page === pageType.RECENT_UPDATED_PAGE) {
      pageName = 'recentUpdatedPage'
    } else if (page === pageType.COMPLETED_PAGE) {
      pageName = 'completedPage'
    } else {
      return null
    }

    option = JSON.parse(jsonArr)
    // let startDate = moment(new Date(), 'YYYYMMDD').add(-1, 'month').format('YYYY-MM-DD')
    // let endDate = moment(new Date(), 'YYYYMMDD').format('YYYY-MM-DD')
    let startDate = ''
    let endDate = ''

    if (page === pageType.RECENT_UPDATED_PAGE) {
      startDate = moment(new Date(), 'YYYYMMDD').add(-6, 'days').format('YYYY-MM-DD')
    }

    if (!option[pageName]) {
      option[pageName] = {income: [], status: [], priority: [], startDate: startDate, endDate: endDate, majorTask: null, middleTask: null, minorTask: null, agent: [], tag: [], search: null, pageSize: 15, order: 'modifyDate', ascending: false}
      localStorage.setItem('TICKET_LIST_OPTION', JSON.stringify(option))
    }

    if (!option[pageName][type]) {
      switch (type) {
        case optionType.INCOME:
        case optionType.STATUS:
        case optionType.PRIORITY:
        case optionType.AGENT:
        case optionType.TAG:
          option[pageName][type] = []
          break
        case optionType.MAJOR_TASK:
        case optionType.MIDDLE_TASK:
        case optionType.MINOR_TASK:
        case optionType.TICKET_SEARCH:
        case optionType.CUSTOMER_SEARCH:
          option[pageName][type] = null
          break
        case optionType.START_DATE:
          option[pageName][type] = startDate
          break
        case optionType.END_DATE:
          option[pageName][type] = endDate
          break
        case optionType.PAGE_SIZE:
          option[pageName][type] = 15
          break
        case optionType.ORDER:
          option[pageName][type] = 'modifyDate'
          break
        case optionType.ASCENDING:
          option[pageName][type] = false
          break
      }

      localStorage.setItem('TICKET_LIST_OPTION', JSON.stringify(option))
    }

    return option[pageName][type]
  } else {
    return option
  }
}

function parseOptionIntoJson (page, jsonArr, data) {
  let result = {}
  if (page === pageType.MY_PAGE) {
    result = {
      myPage: data,
      allPage: jsonArr.allPage,
      recentUpdatedPage: jsonArr.recentUpdatedPage,
      completedPage: jsonArr.completedPage
    }
  } else if (page === pageType.ALL_PAGE) {
    result = {
      myPage: jsonArr.myPage,
      allPage: data,
      recentUpdatedPage: jsonArr.recentUpdatedPage,
      completedPage: jsonArr.completedPage
    }
  } else if (page === pageType.RECENT_UPDATED_PAGE) {
    result = {
      myPage: jsonArr.myPage,
      allPage: jsonArr.allPage,
      recentUpdatedPage: data,
      completedPage: jsonArr.completedPage
    }
  } else if (page === pageType.COMPLETED_PAGE) {
    result = {
      myPage: jsonArr.myPage,
      allPage: jsonArr.allPage,
      recentUpdatedPage: jsonArr.recentUpdatedPage,
      completedPage: data
    }
  }
  return JSON.stringify(result)
}

function checkDateCompare (firstDate, secondDate) {
  return moment(firstDate, 'YYYYMMDDHHmmSS') < moment(secondDate, 'YYYYMMDDHHmmSS')
}

export default {
  getChannelIcon,
  listIntoGetParams: (paramName, listData) => listIntoGetParams(paramName, listData),
  parseTicketEnumIntoString: (data, type) => parseTicketEnumIntoString(data, type),
  getStyleFromTypeText: (type, text) => getStyleFromTypeText(type, text),
  checkItemInTicketSelectedArray: (arr, ticketId) => checkItemInTicketSelectedArray(arr, ticketId),
  getTicketIdsFromTicketArr: (arr) => getTicketIdsFromTicketArr(arr),
  parseHeaderIntoJson: (arr) => parseHeaderIntoJson(arr),
  parseJsonIntoHeader: (json) => parseJsonIntoHeader(json),
  getLeafTaskType: (major, middle, minor) => getLeafTaskType(major, middle, minor),
  parseStoreJsonIntoHeaderStringArr: (jsonArr) => parseStoreJsonIntoHeaderStringArr(jsonArr),
  getExcelDownloadTimeLimitOverFlow: (startDate, endDate) => getExcelDownloadTimeLimitOverFlow(startDate, endDate),
  checkSelectionReset: (data) => checkSelectionReset(data),
  findTaskType: (taskTypes, targetType) => findTaskType(taskTypes, targetType),
  getAvailTaskTypeId: (data) => getAvailTaskTypeId(data),
  checkEndTimeIsAfter: (start, end) => checkEndTimeIsAfter(start, end),
  parseJsonIntoPage: (type, jsonArr) => parseJsonIntoPage(type, jsonArr),
  parseJsonIntoOption: (page, type, jsonArr) => parseJsonIntoOption(page, type, jsonArr),
  parseOptionIntoJson: (type, jsonArr, data) => parseOptionIntoJson(type, jsonArr, data),
  checkDateCompare: (firstDate, secondDate) => checkDateCompare(firstDate, secondDate)
}



// WEBPACK FOOTER //
// ./src/components/menus/ticket/util/ticket_list_util.js